import { render } from "./ListeIntervallePoids.vue?vue&type=template&id=6c79b2f6&ts=true"
import script from "./ListeIntervallePoids.vue?vue&type=script&lang=ts"
export * from "./ListeIntervallePoids.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__